export const CONTACT_LINKS = {
  email: 'valorex.admin@protonmail.com',
  discordUrl: 'https://discord.gg/UwWAVbXaSa',
};

export const SALE_TICKER_CONFIG = {
  enabled: true,
  badge: 'FOR SALE',
  message: 'ValoRex is available for acquisition',
  detail: 'Serious inquiries only',
  email: CONTACT_LINKS.email,
  discordUrl: CONTACT_LINKS.discordUrl,
};
